export default __webpack_public_path__ + "static/media/anuario-bg-2024.00a2d152.jpg";